import React from "react";
import styled from "styled-components";
import service from "../assets/service.webp";

const StyledImage = styled.img`
  width: 90%; /* mobile */
  max-width: 900px; /* desktop */
  height: auto;

  @media (min-width: 1024px) {
    width: 80%;
  }
`;

const Services = () => {
  return (
    <div className="w-full bg-gray-50 ">
      <div className="max-w-[1600px] mx-auto lg:py-16 py-10 border-b">
        <div className="w-11/12 mx-auto flex flex-col items-center gap-8">
          {/* Heading */}
          

          {/* Image Section */}
          <StyledImage src={service} alt="Description of the image" />
        </div>
      </div>
    </div>
  );
};

export default Services;
